import {useContext} from "react";
import CreateQRCodeContext from "../../CreateQRCodeContext";
import WebsiteForm from "../forms/website/WebsiteForm";
import Form from "../../../../_utils/forms/Form";
import {IconSettings} from "@tabler/icons-react";
import FormField from "../../../../_utils/forms/field/FormField";
import {Button} from "@mantine/core";
import {useNavigate} from "react-router-dom";
import Notifications from "../../../../../utils/notifications/Notifications";
import QRCodeContext from "../../../../../contexts/qr-code/QRCodeContext";

function WebsiteInputData() {
    /**
     * CreateQRCodeContext
     * @author Kacper Faber
     * @since 0.1.8
     */
    const ctx = useContext(CreateQRCodeContext);

    /**
     * QRCodeContext - Because we need reload context
     * @author Kacper Faber
     * @since 0.1.9
     */
    const qrCtx = useContext(QRCodeContext);

    /**
     * Navigate function from react-router-dom
     * @author Kacper Faber
     * @since 0.1.8
     */
    const nav = useNavigate();

    /**
     * On saved QR code we redirect to the home page.
     * @author Kacper Faber
     * @since 0.1.8
     */
    const onSaveSuccess = () => {
        nav('/');
        qrCtx.reload();
    }

    /**
     * On save button is clicked.
     * @author Kacper Faber
     * @since 0.1.8
     */
    const onSaveClicked = () => {
        ctx.create()
            .then(onSaveSuccess)
            .catch(Notifications.onFetchError);
    };

    return (
        <div>
            <Form label="Ogólne" icon={<IconSettings size={32}/>}>
                <FormField
                    label="Nazwa"
                    onChange={e => ctx.setPayload({...ctx.payload, name: e.target.value})}
                />
            </Form>

            <WebsiteForm/>

            <Button
                onClick={onSaveClicked}
                children="Zapisz"
            />
        </div>
    );
}

export default WebsiteInputData;

// TODO: WebsiteInputData.tsx
//  Improve the form
//  Move the next button to the overlay.
//  Add form validation...